import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useDroppable } from "@dnd-kit/core";
import type { ReactNode } from "react";

export interface KanbanColumnProps {
  status: string;
  label: string;
  count: number;
  children: ReactNode;
}

export function KanbanColumn({ status, label, count, children }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id: status });

  return (
    <Box
      ref={setNodeRef}
      data-testid={`kanban-column-${status}`}
      sx={{
        width: 280,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        bgcolor: isOver ? "action.hover" : "background.paper",
        border: "1px solid",
        borderColor: isOver ? "primary.main" : "divider",
        borderRadius: 2,
        maxHeight: "calc(100vh - 220px)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 1.5, borderBottom: "1px solid", borderColor: "divider" }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {label}
        </Typography>
        <Chip label={count} size="small" />
      </Stack>
      <Stack spacing={1} sx={{ p: 1.5, overflowY: "auto", flexGrow: 1, minHeight: 0 }}>
        {children}
      </Stack>
    </Box>
  );
}
